import React from 'react'
import { Grid } from '@material-ui/core'
import classNames from 'classnames'

import useStyles from '../styles'

export function SkeletonColumnHeader({ column, minimizedColumns }) {
  const styles = useStyles()

  // Check if column is minimized (only if props are provided)
  const isMinimized = column && minimizedColumns ? minimizedColumns.has(column.id) : false

  // Gera larguras aleatórias para o título e contador
  const titleWidth = Math.floor(Math.random() * (200 - 100 + 1)) + 100 // 100-200px
  const countWidth = Math.floor(Math.random() * (60 - 40 + 1)) + 40 // 40-60px

  if (isMinimized) {
    // Skeleton for minimized column (vertical layout)
    return (
      <Grid className={styles.minimizedColumnHeaderWrapper}>
        <div className={classNames(styles.shimmer, styles.minimizedButtonSkeleton)} />
        <div className={classNames(styles.shimmer, styles.minimizedTitleSkeleton)} />
        <div className={classNames(styles.shimmer, styles.minimizedCountSkeleton)} />
      </Grid>
    )
  }

  // Normal skeleton (horizontal layout)
  return (
    <Grid className={styles.columnHeaderWrapper}>
      <div
        className={classNames(styles.shimmer, styles.titleSkeleton)}
        style={{ width: `${titleWidth}px` }}
      />
      <div
        className={classNames(styles.shimmer, styles.countSkeleton)}
        style={{ width: `${countWidth}px` }}
      />
    </Grid>
  )
}
